/* projects/speaker-platform/src/app/organisms/admin/speaker-edit-presentation/speaker-edit-presentation.component.scss */
.editpresentation__photo {
  width: 145px;
  height: 145px;
  margin-bottom: 16px;
  background-color: #ADADAD;
  text-align: center;
  border-radius: 50%;
}
.editpresentation__photo img {
  border-radius: 50%;
}
/*# sourceMappingURL=speaker-edit-presentation.component-UKX3WE3E.css.map */
